import { owned } from "../model/handles.js";
import { assertOwner, validId } from "../model/validation.js";
import { normalizeJson } from "./value.js";
export function createRecordDefinition(id, options, owner) {
    validId(id, "record");
    assertOwner(options.scope, owner, `Scope for ${id}`);
    requireVersion(options.version, `Record ${id}`);
    const initial = normalizeJson(options.validate(options.initial), `Record ${id}`);
    return owned({
        id,
        scope: options.scope,
        version: options.version,
        initial,
        validate: options.validate,
        ...(options.migrate ? { migrate: options.migrate } : {}),
    }, owner);
}
export function createDomainEventDefinition(id, options, owner) {
    validId(id, "domain event");
    requireVersion(options.version, `Domain event ${id}`);
    return owned({
        id,
        version: options.version,
        validate: options.validate,
        ...(options.migrate ? { migrate: options.migrate } : {}),
    }, owner);
}
function requireVersion(version, label) {
    if (!Number.isSafeInteger(version) || version < 1) {
        throw new TypeError(`${label} version must be a positive safe integer`);
    }
}
//# sourceMappingURL=builders.js.map